'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ClientSideComponent2 = require('core/ClientSideComponent');

var _ClientSideComponent3 = _interopRequireDefault(_ClientSideComponent2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./AutoCollapser.scss');

var cn = _bind2.default.bind(styles);

var AutoCollapser = (_class = (_temp = _class2 = function (_ClientSideComponent) {
  (0, _inherits3.default)(AutoCollapser, _ClientSideComponent);

  function AutoCollapser() {
    var _ref;

    (0, _classCallCheck3.default)(this, AutoCollapser);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoCollapser.__proto__ || (0, _getPrototypeOf2.default)(AutoCollapser)).call.apply(_ref, [this].concat(args)));

    _this.state = { collapsable: false, collapsed: false };
    return _this;
  }

  (0, _createClass3.default)(AutoCollapser, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _get3.default)(AutoCollapser.prototype.__proto__ || (0, _getPrototypeOf2.default)(AutoCollapser.prototype), 'componentDidMount', this).call(this, this.initCollapser);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.children !== this.props.children) {
        this.changeCollapser({ collapsed: false });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.changeCollapser);
      }
    }
  }, {
    key: 'initCollapser',
    value: function initCollapser() {
      if (typeof window !== 'undefined') {
        window.addEventListener('resize', this.changeCollapser);
      }
      this.changeCollapser();
    }
  }, {
    key: 'changeCollapser',
    value: function changeCollapser() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$collapsed = _ref2.collapsed,
          collapsed = _ref2$collapsed === undefined ? this.state.collapsed : _ref2$collapsed;

      var contentRect = this.contentEl.getBoundingClientRect();
      var wrapperRect = this.wrapperEl.getBoundingClientRect();
      var collapsable = contentRect.width > wrapperRect.width;
      this.setState({ collapsable: collapsable, collapsed: collapsed });
    }
  }, {
    key: 'initContentEl',
    value: function initContentEl(el) {
      this.contentEl = el;
    }
  }, {
    key: 'initWrapperEl',
    value: function initWrapperEl(el) {
      this.wrapperEl = el;
    }
  }, {
    key: 'toggle',
    value: function toggle() {
      var collapsed = this.state.collapsed;

      this.setState({ collapsed: !collapsed });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          contentClass = _props.contentClass,
          iconClass = _props.iconClass;
      var _state = this.state,
          collapsed = _state.collapsed,
          collapsable = _state.collapsable,
          isMounted = _state.isMounted;


      return _react2.default.createElement(
        'div',
        {
          className: cn('wrapper', { collapsed: collapsed, collapsable: collapsable, isMounted: isMounted }, className),
          onClick: this.toggle,
          ref: this.initWrapperEl
        },
        _react2.default.createElement(
          'div',
          { className: (0, _bind2.default)(styles.content, contentClass) },
          children
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _bind2.default)(styles.content, styles.fake, contentClass), ref: this.initContentEl },
          children
        ),
        _react2.default.createElement('i', { className: (0, _bind2.default)(styles.collapser, iconClass) })
      );
    }
  }]);
  return AutoCollapser;
}(_ClientSideComponent3.default), _class2.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node, _propTypes2.default.arrayOf(_propTypes2.default.node)]),
  className: _propTypes2.default.string,
  contentClass: _propTypes2.default.string,
  iconClass: _propTypes2.default.string
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'initCollapser', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'initCollapser'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'changeCollapser', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'changeCollapser'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'initContentEl', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'initContentEl'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'initWrapperEl', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'initWrapperEl'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggle', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'toggle'), _class.prototype)), _class);
exports.default = AutoCollapser;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AutoCollapser/AutoCollapser.js
// module id = 1957
// module chunks = 1